import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const ArrowUpThin = (props) => (
  <Icon viewBox="0 0 10 6" {...props}>
    <g>
      <title>v</title>
      <path d="M1 5l4-4 4 4" stroke="currentColor" fill="none" fillRule="evenodd" />
    </g>
  </Icon>
);
/*eslint-enable */

export default ArrowUpThin;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/ArrowUpThin.js